var _path, _path2, _path3, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTipsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 28,
    viewBox: "0 0 26 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9838_5354)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4399 20.5H10.5669C10.0799 20.5 9.99992 21.001 9.99992 20.5L9.75492 21.15C9.75492 19.98 9.26792 18.81 8.37492 17.892C7.74073 17.2439 7.24741 16.4716 6.92594 15.6237C6.60448 14.7758 6.46182 13.8706 6.50692 12.965C6.66892 9.45797 9.51092 6.61897 12.9219 6.53497H13.0029C16.5759 6.53497 19.4999 9.54097 19.4999 13.215C19.4999 14.97 18.8499 16.723 17.5499 17.975C16.6579 18.811 16.2519 19.98 16.2519 21.149L16.2699 20.718C16.2699 21.218 15.9269 20.5 15.4399 20.5Z",
    stroke: "#76BC21",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 26.248C11.212 26.248 9.75 24.808 9.75 23.048V21.448C9.75 20.968 10.075 20.648 10.562 20.648H15.437C15.925 20.648 16.25 20.968 16.25 21.448V23.048C16.25 24.808 14.787 26.248 13 26.248Z",
    stroke: "#76BC21",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9838_5354",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 26,
    height: 28
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H26V28H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9838_5354)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4021 16.217H25.3041",
    stroke: "#76BC21",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.812988 16.158H3.71399",
    stroke: "#76BC21",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0901 7.62703L23.1331 5.55603",
    stroke: "#76BC21",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9449 3.792L12.9399 0.875",
    stroke: "#76BC21",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.93197 7.72201L2.84497 5.69501",
    stroke: "#76BC21",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9838_5354"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTipsIcon);
export default __webpack_public_path__ + "static/media/tipsIcon.3c9e8176cd759fcf89554a470c21ce57.svg";
export { ForwardRef as ReactComponent };